import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { loadAnalytics } from "../lib/analytics";

const SiteCtx = createContext({ site: null });

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const refresh = useCallback(() => api.get("/public/site").then((r) => setSite(r.data)).catch(() => setSite({})), []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  useEffect(() => {
    if (site?.analytics) loadAnalytics(site.analytics);
  }, [site]);
  return <SiteCtx.Provider value={{ site, refresh }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
